
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { formatCurrency } from '@core/utils/number.utils';
import { PaymentMethod } from '@core/types/cash';
import { ICashSessionPaymentMethodRowView } from '@models/cashSession.interface';

type CountedControlMap = Partial<
  Record<PaymentMethod, AbstractControl<any, any> | null>
>;

@Component({
    selector: 'app-cash-session-payment-methods-table',
    imports: [ReactiveFormsModule],
    templateUrl: './cash-session-payment-methods-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CashSessionPaymentMethodsTableComponent {
  @Input() title = 'Conciliación por método';
  @Input() subtitle = '';
  @Input() rows: ICashSessionPaymentMethodRowView[] = [];
  @Input() countedControls: CountedControlMap | null = null;
  @Input() editableCounted = false;
  @Input() showIcons = true;
  @Input() showDifferenceLabel = true;

  readonly formatCurrency = formatCurrency;

  getCountedControl(
    bucket: PaymentMethod,
  ): FormControl<number | null> | null {
    const control = this.countedControls?.[bucket] ?? null;
    return control instanceof FormControl ? control : null;
  }

  handleCountedFocus(control: FormControl<number | null>): void {
    if (Number(control.value ?? 0) !== 0) {
      return;
    }

    control.setValue(null);
  }

  handleCountedBlur(control: FormControl<number | null>): void {
    control.markAsTouched();
  }

  getDifferenceClass(value: number | null | undefined): string {
    const amount = Number(value ?? 0);

    if (!Number.isFinite(amount) || amount === 0) {
      return 'text-slate-700 dark:text-slate-200';
    }

    if (amount > 0) {
      return 'text-emerald-700 dark:text-emerald-300';
    }

    return 'text-rose-700 dark:text-rose-300';
  }

  getDifferenceLabel(value: number | null | undefined): string {
    const amount = Number(value ?? 0);

    if (!Number.isFinite(amount) || amount === 0) {
      return 'Sin diferencia';
    }

    return amount > 0 ? 'Sobrante' : 'Faltante';
  }

  getMethodIconClass(bucket: PaymentMethod): string {
    if (bucket === 'cash') return 'fa-solid fa-money-bill-wave';
    if (bucket === 'debit_card') return 'fa-solid fa-credit-card';
    if (bucket === 'credit_card') return 'fa-regular fa-credit-card';
    if (bucket === 'transfers') return 'fa-solid fa-building-columns';
    if (bucket === 'other') return 'fa-solid fa-wallet';
    return 'fa-solid fa-money-check-dollar';
  }
}
